module.exports = __webpack_public_path__ + "img/poster.f83403dd.png";